export const about = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Aspiring Software Engineer",
  headline: "Matthew Ray Lee",
  description: `I'm a passionate computer science graduate with a strong drive \
  for innovation. Throughout my academic journey, I've been fueled by my love \
  for coding and problem-solving to do impactful work. During my time as an \
  API Developer Intern, I had the opportunity to optimize rail transportation \
  through updating and testing multiple APIs. I am excited to continue \
  exploring new technologies and be part of an innovative team that makes a \
  positive impact. Feel free to explore my projects and reach out for \
  collaborations or exciting opportunities. `,
  buttonLabel: "Hire Me!",
  imgStart: true,
  img: require("../../images/matt_about1.jpg"),
  alt: "matt about 1",
  dark: true,
  primary: true,
  darkText: false,
};

export const contact = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Software Engineer",
  headline: "Seeking Full-time Job By 2023",
  description: "Graduating May 2023",
  buttonLabel: "Hire Me!",
  imgStart: true,
  img: require("../../images/golf.svg"),
  alt: "Golf",
  dark: false,
  primary: true,
  darkText: true,
};
